module.exports = __webpack_public_path__ + "static/media/12UNCTAD20.2c6b2574.jpg";